import { render, staticRenderFns } from "./IoForm.vue?vue&type=template&id=3db937e8&"
import script from "./IoForm.vue?vue&type=script&lang=js&"
export * from "./IoForm.vue?vue&type=script&lang=js&"
import style0 from "./IoForm.vue?vue&type=style&index=0&id=3db937e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports